// extracted by mini-css-extract-plugin
export default {"title":"AlertDialog_title__U5Ds2","actions":"AlertDialog_actions__oeZeK","action-button":"AlertDialog_action-button__rxB33"};